export enum TabType {
  NotSubscribed = "not_enrolled",
  Failed = "error",
  Subscribed = "enrolled",
  All = "All"
}
